import React, { FC } from 'react';
import styles from '../EnvelopeItem.module.scss';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { EnvelopeAllovedActions, EnvelopeDirection } from '@const/consts';

import { getIcon, IconCheck, IconInfo, LibTooltipPosition } from '@infologistics/frontend-libraries';

import { IEnvelopIconsProps as IProps } from '@views/envelopes/types';
import { useAppSelector } from '@hooks/redux';
import SystemHint from '@common/SystemHint';
import { ACTION_REQUIRED_FOLDER } from '@hooks/envelopes/useGetParams';

const EnvelopeIcons: FC<IProps> = ({ directions, allowedActions }) => {
  const { direction } = useAppSelector(state => state.envelopes.envelopes)
  const { directionOrFolder } = useParams()
  const { t } = useTranslation(['envelopes'])

  const isDirectionIcon = directions && directions.length === 1
  const isDirectionIconIncoming = directions && directions[0] === EnvelopeDirection.INCOMING
  const isActionRequiredFolder = directionOrFolder === ACTION_REQUIRED_FOLDER
  const isAllowedActionsSignOrApprove =
    allowedActions.includes(EnvelopeAllovedActions.SIGN) ||
    allowedActions.includes(EnvelopeAllovedActions.APPROVE)
  const renderDirectionIcon = () => {
    if (!isDirectionIcon) return null

    return (
      <SystemHint
        content={isDirectionIconIncoming ? t('envelopes:incoming') : t('envelopes:outgoing')}
        position={LibTooltipPosition.BOTTOM}
      >
        <span className='d-inline-flex'>
          {getIcon(isDirectionIconIncoming ? 'IconIncomingAlt' : 'IconOutgoingAlt', {
            color: 'gray-500',
            size: 'sm',
          })}
        </span>
      </SystemHint>
    )
  }

  if (isActionRequiredFolder) {
    return (
      <td>
        <div className={styles.iconsStack}>
          <span className={cn('d-flex justify-content-center', styles.flowState)}>
            {renderDirectionIcon()}
          </span>
        </div>
      </td>
    )
  }

  return (
    <td>
      <div className={styles.iconsStack}>
        <span className={cn('d-flex justify-content-center', styles.flowState)}>
          {
            isAllowedActionsSignOrApprove ?
              (
                <SystemHint
                  content={t('envelopes:actionRequired')}
                  position={LibTooltipPosition.BOTTOM}
                >
                  <span className='d-inline-flex'>
                    <IconInfo color='primary-500' />
                  </span>
                </SystemHint>
              ) : (
                <SystemHint
                  content={t('envelopes:noActionRequired')}
                  position={LibTooltipPosition.BOTTOM}
                >
                  <span className='d-inline-flex'>
                    <IconCheck />
                  </span>
                </SystemHint>
              )
          }
        </span>
        { direction === null &&
          <span className={cn('d-flex justify-content-center', styles.directions)}>
            {renderDirectionIcon()}
          </span>
        }
      </div>
    </td>
  );
}

export default EnvelopeIcons
